import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema } from '../../../../util';
import {
  ACS_BASIC_03_Schema,
  extractStatData,
  extractAccidentRateData,
} from './ACS_BASIC_03_Schema';

/**
 * 통계 조회 (GetAccBasic03R1) - 월별/유형별/요일별/부서별/시간대별/근속년수별 6종
 * onSuccess(statData) → { byMonth, byType, byDayOfWeek, byDept, byTime, byTenure }
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(ACS_BASIC_03_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['AccidentStatus', 'getAccBasic03R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.AccidentStatus.getAccBasic03R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess || !query.data) return;
    const statData = extractStatData(query.data);
    if (statData) onSuccess?.(statData);
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/**
 * 재해율 조회 (GetAccBasic04R1) - 상시근로자수, 재해건수, 재해율(%)
 * 재해율 = (재해건수/상시근로자수)*100 (서버 계산)
 * onSuccess(accidentRateData) → { workerCount, accidentCount, accidentRate }
 */
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(ACS_BASIC_03_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['AccidentStatus', 'getAccBasic04R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.AccidentStatus.getAccBasic04R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess || !query.data) return;
    const accidentRateData = extractAccidentRateData(query.data);
    if (accidentRateData) onSuccess?.(accidentRateData);
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
